var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.665,
    height: 130,
    viewBox: "0 0 121.665 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 121.665,
    height: 130,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Btn_Home",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M71.138,4.373a14.928,14.928,0,0,0-21.112,0L.487,53.91,0,122.126A7.818,7.818,0,0,0,7.818,130H113.847a7.826,7.826,0,0,0,7.818-7.818V54.9Zm1.379,114.256H49.147V81.43h23.37Zm37.777,0H83.888V70.059H37.776v48.57H11.4l.428-59.975L58.067,12.413a3.558,3.558,0,0,1,5.031,0l47.2,47.2Z",
    transform: "translate(0)",
    fill: "#1152e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefault);
export default __webpack_public_path__ + "static/media/home-default.60cdedd3e5781da671530982e2f9e2c9.svg";
export { ForwardRef as ReactComponent };